import type { OrganizationState, State } from 'src/store/types.js';
import { getOrganization } from 'src/store/selectors';
import type { AbstractPageView } from 'src/pages/abstract-page-view';
import type { TutorialsPageViewModel } from '../../pages/tutorials-page/tutorials-page-view-model';
import type { IconEnum } from '../../pages/icon-enum';
import type { ListSectionItemInput } from '../../library/lists/listSectionItemInput';
import { tutorialsForOrganization } from 'src/store/selectors/tutorials-for-organization';
import { sortBy } from 'lodash';
import { secondaryLabelForTutorial } from './tutorial-list-helpers';

function tutorialsAsListItems(organization: OrganizationState | undefined, hrefPrefix: string): ListSectionItemInput[] {
  if (organization) {
    const items: ListSectionItemInput[] = tutorialsForOrganization(organization).map((t) => {
      return {
        label: t.title,
        secondaryLabel: secondaryLabelForTutorial(t),
        accessible: true,
        updateStatus: 'none' as const,
        href: hrefPrefix + 'tutorials/' + t.id,
      };
    });
    // Sort tutorials alphabetically by title
    return sortBy(items, (e) => e.label);
  }
  return [];
}

export function tutorialsPageView(
  doctype: IconEnum,
  hrefPrefix: string,
  viewModel: AbstractPageView,
  state: State,
): TutorialsPageViewModel {
  return {
    ...viewModel,
    type: 'tutorials-page',
    icon: doctype,
    href: hrefPrefix,
    availableActivityCodes: [],
    pdfHref: '',
    list: tutorialsAsListItems(getOrganization(state), hrefPrefix),
  };
}
